export default {
      id: "ic_chevron_down-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic_chevron_down-usage",
      toString: function () {
        return this.url;
      }
    }